// extracted by mini-css-extract-plugin
export default {"element":"styles_element__1fEWR"};